import PatientStanceContainer from './PatientStanceContainer';

export default PatientStanceContainer;
